import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Page} from '../../../model/page';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {AuthService} from '../../../auth/auth.service';
import tableCols from './whatsnew.cols';
//import {MasterCustomerService} from '../services/master-customer.service';
import {WhatsNewService} from '../services/whatsnew.service';
import {ToastrService} from 'ngx-toastr';
import {IWhatsNew} from '../interfaces/IWhatsNew';
import {permissions} from '../../../permissions';
import {ConfirmationService} from 'primeng/api';
import {Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs/Subscription';

@Component({
    templateUrl: './whatsnew.component.html',
    providers: [
        AuthService,
        WhatsNewService,
       // MasterCustomerService,
    ]
})
export class WhatsNewComponent implements OnInit, OnDestroy {

    @ViewChild('dataView') dataView: ElementRef;
    @ViewChild('actionbar') actionbar: ElementRef;
    @ViewChild('content') content: ElementRef;
    @ViewChild('tableHeader') tableHeader: ElementRef;
    @ViewChild('paginator') paginator: ElementRef;

    private permissions = permissions;
    private subscription: Subscription;

    public page = new Page();
    rows = new Array<IWhatsNew>();
    cols = [];
    totalRecords = 0;
    size = 50;
    private selected: any = [];
    private viewFilters = false;
    public filtersApplied: boolean;
    private loading = false;
    public userActionLoading = false;
    public isWorkspaceSelected: boolean;

    private scrollHeight = '50px';
    private dialogContentHeight = '150px';

    private yesNoFlags: Array<object> = [
        {value: null, text: 'All'},
        {value: 'x', text: 'Yes'},
        {value: '', text: 'No'}
    ];

    private customersFlag: Array<object> = [];

    constructor(
        private whatsNewService: WhatsNewService,
        //private customerService: MasterCustomerService,
        private authService: AuthService,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.page.size = 50;
        this.title.setTitle('What\'s New');
    }

    ngOnInit() {
        this.filtersApplied = false;
        this.isWorkspaceSelected = this.getSelectedWorkspace();
        this.cols = tableCols;

        const filterParams = this.route.snapshot.queryParams;
        this.parseParams( filterParams );

        if (this.isWorkspaceSelected) {
            this.getData(false);
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    parseParams( filterParams ) {
        if (filterParams !== undefined && filterParams !== null) {
            let showFilters = false;
            for (const key of Object.keys(filterParams)) {
                const value = filterParams[key];
                if (value && value.toString() !== '') {
                    if (key.toString() === 'page') {
                        this.page.pageNumber = Number(value);
                    } else if (key.toString() === 'perPage') {
                        this.page.size = Number(value);
                        this.size = Number(value);
                    } else {
                        this.page.filterParams[key] = value;
                        showFilters = true;
                    }
                }
            }
            this.viewFilters = showFilters;
            this.filtersApplied = showFilters;
        }
    }

    getData(reloadWithParams = true) {
        this.setPage({offset: this.page.pageNumber}, reloadWithParams);
    }

    setPage(pageInfo, reloadWithParams = true) {
        if (reloadWithParams) {
            this.page.filterParams['page'] = pageInfo.offset ? pageInfo.offset : 0;
            this.page.filterParams['perPage'] = pageInfo.size ? pageInfo.size : this.size;
            this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
                return false;
            }
            this.router.navigate([], { relativeTo: this.route, queryParams: this.page.filterParams });
        } else {
            this.loading = true;
            this.selected = [];
            this.subscription = this.whatsNewService.getDataList(this.page).subscribe(result => {
                this.totalRecords = result.count;
                this.page.totalPages = result.count / this.page.size;
                this.rows = result.data;
                setTimeout(() => {
                    this.scrollHeight = this.getScrollHeight() + 'px';
                });
                this.loading = false;
            }, error => {
                this.loading = false;
                window.dispatchEvent(new Event('resize'));
                this.toastr.error('TimeOut occured', 'Service Error', {
                    timeOut: 3000,
                });
            });
        }
    }

    buttonPress(e, col, value) {
        if (e.keyCode === 13) {
            this.filterChanged(col, value);
        }
    }

    clearFilters() {
        this.page.filterParams = {};
        this.viewFilters = false;
        this.filtersApplied = false;
        this.page.pageNumber = 0;
        this.setPage({offset: this.page.pageNumber});
    }

    filterChanged(col, value) {
        this.loading = true;
        if (col === 'PL1_SHOW_DEFAULT') {
            this.page.filterParams[col] = value;
        } else if ((col === 'ORDERED_ON' || col === 'COMPLETED_ON' || col === 'MODIFIED_ON' || col === 'CREATED_ON')
            && value === '01-01-1970' || value === '') {
            delete this.page.filterParams[col];
        } else {
            this.page.filterParams[col] = value;
        }
        this.filtersApplied = Object.keys(this.page.filterParams).length > 0;
        this.page.pageNumber = 0;
        this.setPage({offset: this.page.pageNumber});
    }

    getContentDialogHeight(): number {
        return (this.dataView.nativeElement.parentElement.parentElement.parentElement.offsetHeight) -
            (this.actionbar.nativeElement.offsetHeight + 48);
    }

    getScrollHeight(): number {
        return this.getContentDialogHeight() - (this.tableHeader.nativeElement.offsetHeight
            + this.paginator.nativeElement.offsetHeight + 52 + (this.viewFilters ? 52 : 0));
    }

    getSelectedWorkspace() {
        return this.authService.workspaceMasterCustomerID !== null;
    }

    get masterDataViewHeight() {
        return this.dataView.nativeElement.parentElement.parentElement.parentElement.offsetHeight
    }

    get masterActionBarHeight() {
        return this.actionbar.nativeElement.offsetHeight + 48
    }

    exportClick() {
        return '';
    }

    onPage($event) {
        this.setPage({
            offset: $event.first / $event.rows,
            size: $event.rows
        });
    }

    onEdit(plant: IWhatsNew) {
        this.router.navigate(['whatsnew/edit/' + plant.WN1_ID]);
    }

    newClick() {
        this.router.navigate(['whatsnew/add']);
    }

    deleteClick() {
        if (this.selected.length > 0) {
            const selectedPlantNames = this.selected.map(plant => plant.WN1_VERSION);
            this.confirmationService.confirm({
                header: 'Delete',
                message: 'Are you sure to delete' + (selectedPlantNames.length > 1 ? 's' : '') + ' '
                    + selectedPlantNames.join(', ') + '?',
                accept: () => {
                    this.userActionLoading = true;
                    this.whatsNewService.delete(this.selected).subscribe((result) => {
                        if (result.success) {
                            this.toastr.info('Delete request successful', 'Request Complete');
                            this.userActionLoading = false;
                            this.getData();
                        } else {
                            this.toastr.error('Unable to complete delete request', 'Error');
                            this.userActionLoading = false;
                        }
                    }, () => {
                        this.toastr.error('Request timed out', 'Service Error');
                        this.userActionLoading = false;
                    });
                }
            })
            //this.getData();
        }
    }

    refreshClick() {
        this.getData(false);
    }

    toggleFilterView() {
        this.viewFilters = !this.viewFilters;
        if (this.viewFilters) {
            setTimeout(() => {
                this.scrollHeight = this.getScrollHeight() + 'px';
            }, 100);
        }
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/whatsnew/whatsnew/whatsnew.component.ts